import { render, staticRenderFns } from "./zqIndex.vue?vue&type=template&id=f62e1b7a&scoped=true"
import script from "./zqIndex.vue?vue&type=script&lang=js"
export * from "./zqIndex.vue?vue&type=script&lang=js"
import style0 from "./zqIndex.vue?vue&type=style&index=0&id=f62e1b7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62e1b7a",
  null
  
)

export default component.exports